namespace Gamification.Gamification {
    export class ProdottiClassiEditorColumns {
        static columnsKey = 'Gamification.ProdottiClassiEditor';
    }
}
